import React from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "reactstrap";

const TermsAndCondition = () => {
  return (
    <>
      <Container fluid className="term-and-condition-main">
        <div className="py-4 px-1 px-sm-4">
          <Link to="/home">
            <Button color="primary">Back</Button>
          </Link>
        </div>
        <Card className="p-3 mx-auto" style={{ maxWidth: "900px" }}>
          <h5 className="text-center mb-3 terms-title text-primary">TOPICS</h5>
          <Row className="g-3 mx-2 mx-sm-3">
            {[
              "Smart Goals",
              "Technique",
              "Favorite Moment",
              "Dream Assignment",
              "Hobbies/pets/Music",
              "Role Model",
              "Diet/Conditioning",
              "Inspiration",
              "Mental Tips",
              "Staying Positive",
              "Self-Talk Mantras",
              "Teamwork Skills",
            ].map((item, index) => (
              <Col xs="12" md="6" lg="4" key={index}>
                <li className="mb-2">{item}</li>
              </Col>
            ))}
          </Row>
          <Row className="mt-3 mx-2 mx-sm-3">
            <Col sm="12" className="d-flex align-items-center">
              <h4 className="terms-text">
                Here are some optional 'topics' for questions to be posed by Fan
                in Question Database. Teacher-athletes answer such Fan questions
                during chats.
              </h4>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
};

export default TermsAndCondition;
